import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import buefy from "buefy";
// import "buefy/dist/buefy.css";
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faAngleLeft,
  faAngleRight,
  faArchive,
  faArrowDown,
  faArrowUp,
  faEdit,
  faEnvelope,
  faExclamationCircle,
  faEye,
  faInfoCircle,
  faPlus,
  faQuoteLeft,
  faSpinner,
  faTimes,
  faTrash,
  faUpload,
  faUser,
  faUserSlash,
  faBold,
  faItalic,
  faStrikethrough,
  faUnderline,
  faCode,
  faHeading,
  faListUl,
  faListOl,
  faUndo,
  faRedo,
  faMinus,
  faAlignLeft,
  faAlignRight,
  faAlignCenter,
  faLink,
  faUnlink,
  faCalendar,
  faClock,
  faCheck,
  faArrowLeft,
  faCartPlus,
  faShoppingCart,
  faQuoteRight,
  faTimesCircle,
  faSearch,
  faClipboardList,
  faStore,
  faStoreSlash,
  faEyeSlash,
} from "@fortawesome/free-solid-svg-icons";

import {
  faCcPaypal,
  faIdeal,
  faPaypal,
} from "@fortawesome/free-brands-svg-icons";

import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

library.add(
  faAngleLeft,
  faAngleRight,
  faQuoteLeft,
  faUpload,
  faExclamationCircle,
  faTimes,
  faEye,
  faArrowUp,
  faArrowDown,
  faPlus,
  faEnvelope,
  faEdit,
  faUserSlash,
  faArchive,
  faInfoCircle,
  faSpinner,
  faUser,
  faTrash,
  faBold,
  faItalic,
  faStrikethrough,
  faUnderline,
  faCode,
  faHeading,
  faListUl,
  faListOl,
  faQuoteLeft,
  faUndo,
  faRedo,
  faMinus,
  faAlignLeft,
  faAlignRight,
  faAlignCenter,
  faLink,
  faUnlink,
  faCalendar,
  faClock,
  faCheck,
  faArrowLeft,
  faCartPlus,
  faShoppingCart,
  faQuoteLeft,
  faQuoteRight,
  faTimesCircle,
  faEnvelope,
  faSearch,
  faClipboardList,
  faStore,
  faStoreSlash,
  faEyeSlash
);

Vue.component("icon", FontAwesomeIcon);

import customInput from "@/components/form/input.vue";
import formAutocomplete from "@/components/form/formAutocomplete.vue";
import formtextArea from "@/components/form/formTextarea.vue";
import numberInput from "@/components/form/numberInput.vue";
import formSelect from "@/components/form/formSelect.vue";
import pictureUpload from "@/components/form/pictureUpload.vue";
import formTags from "@/components/form/tags.vue";
import formTagsAutocomplete from "@/components/form/tagsAutocomplete.vue";
import formButton from "@/components/form/formButton.vue";
import showModel from "@/components/form/showModel.vue";
import formCheckbox from "@/components/form/formCheckbox.vue";
import formDatePicker from "@/components/form/formDatePicker.vue";
import formTimePicker from "@/components/form/formTimePicker.vue";
import formDateTimePicker from "@/components/form/formDateTimePicker.vue";
import formEditor from "@/components/form/editor/Editor.vue";
import carrousel from "@/views/Components/Carrousel.vue";

import settingsCard from "@/components/settings/settingsCard.vue";

Vue.component("settingsCard", settingsCard);
Vue.component("formInput", customInput);
Vue.component("formAutocomplete", formAutocomplete);
Vue.component("formTextarea", formtextArea);
Vue.component("numberInput", numberInput);
Vue.component("showModel", showModel);
Vue.component("formSelect", formSelect);
Vue.component("formPictureUpload", pictureUpload);
Vue.component("formTags", formTags);
Vue.component("formTagsAutocomplete", formTagsAutocomplete);
Vue.component("formButton", formButton);
Vue.component("formCheckbox", formCheckbox);
Vue.component("formTimePicker", formTimePicker);
Vue.component("formDatePicker", formDatePicker);
Vue.component("formDateTimePicker", formDateTimePicker);
Vue.component("icon", FontAwesomeIcon);
Vue.component("formEditor", formEditor);
Vue.component("carrousel", carrousel);

import { axiosrequest } from "@/globals/interceptors.js";
import { axiosresponse } from "@/globals/interceptors.js";

import vuemixins from "@/globals/mixins/mixins.js";
Vue.mixin(vuemixins);

Vue.config.productionTip = false;
Vue.use(buefy, {
  defaultIconComponent: "icon",
  defaultIconPack: "fas",
});

import routerMiddleware from "@/globals/middleware/beforeEach";
router.beforeEach(routerMiddleware);

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
